import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import HeroVenue from "../components/Hero_venue";
import heroImage from "../assets/calender_hero.jpg";
import DataAccordion from "../components/DataAccordian";
import eventsData from "../data/events.json";
import { DateTime } from "luxon";
import Canonical from "../components/canonical";

function EventMonth({ month, events }) {
  const monthString = DateTime.fromObject({ month }).toFormat("MMMM");

  return (
    <>
      <Canonical />
      <p className="mx-6 md:text-xl sm:text-lg text-sm my-4">
        <div className="uppercase my-8 mx-4 md:text-4xl text-xl sm:text-2xl font-bold items-start text-center  ">
          <h1>{monthString}</h1>
        </div>
      </p>
      {events.map((e) => (
        <DataAccordion {...e} />
      ))}
    </>
  );
}

export function Calendar() {
  const heroName = "Calendar";

  const now = Date.now();

  const events = eventsData.events
    .map((e) => ({ ...e, eventDate: Date.parse(e.eventDate) }))
    .filter((e) => e.eventDate > now)
    .sort(
      (a, b) => a.eventDate - b.eventDate, // For ascending order
    )
    .reduce((acc, obj) => {
      // Get the month and year from the timestamp
      const month = DateTime.fromMillis(obj.eventDate).toFormat("MM");

      // If the monthYear doesn't exist in the accumulator, create it as an empty array
      if (!acc[month]) {
        acc[month] = [];
      }

      // Push the object into the corresponding month-year group
      acc[month].push(obj);

      return acc;
    }, {});

  return (
    <React.Fragment>
      <Navbar linkName="Home" />
      <HeroVenue heroAreaName={heroName} imageSrc={heroImage} />
      <div className="bg-[#075AAA] w-full mx-auto flex flex-col items-center justify-center text-white">
        <div className="uppercase my-8 mx-4 md:text-4xl text-xl sm:text-2xl font-bold items-start text-center  ">
          <h1>Events</h1>
        </div>
        <div className="max-w-[1248px] flex flex-wrap gap-x-4 pb-4 text-center">
          <p className="mx-6 md:text-xl sm:text-lg text-sm my-4">
            We are a very active club and offer a large array of events
            throughout the year, please check this page regularly for events,
            updates and competitions.
          </p>
        </div>
        <div className="bg-[#ffffff] w-full mx-auto flex flex-col items-center justify-center text-[#01184D] py-4">
          <p className="mx-6 md:text-xl sm:text-lg text-sm my-4">
            <div className="uppercase my-8 mx-4 md:text-4xl text-xl sm:text-2xl font-bold items-start text-center  ">
              <h1>Upcoming 2026/27 Events</h1>
            </div>
          </p>

          {Object.keys(events)
            .map(Number) // Convert string keys to numbers
            .sort((a, b) => a - b) // Sort numerically
            .map((month) => (
              <EventMonth
                month={month}
                events={events[String(month).padStart(2, "0")]}
              />
            ))}
        </div>
      </div>
      <Footer year={new Date().getFullYear()} />
    </React.Fragment>
  );
}
